import { RenderHtml } from '../../../utils';
import * as React from 'react';
export var HtmlComponent = function (props) {
    return (React.createElement("div", { className: 'component html-component', "data-component-type": 'html' },
        React.createElement(RenderHtml, { html: props.value.html, className: 'rendered-html' })));
};
//# sourceMappingURL=html-component.comp.js.map